import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import Layout from './layouts/Layout';
import AuthLayout from './layouts/AuthLayout';
import Login from './components/authentication/card/Login';
import Register from './components/authentication/card/Register';
import ForgetPassword from './components/authentication/simple/ForgetPassword';
import PasswordReset from './components/authentication/simple/PasswordReset';
import ConfirmMail from './components/authentication/simple/ConfirmMail';
import ErrorLayout from './layouts/ErrorLayout';
import Logout from './components/authentication/card/Logout';
import LandingDev from './components/pages/landing/LandingDev';
import ContactUs from './components/pages/info/ContactUs';
import TermsCondition from './components/pages/info/TermsCondition';
import RefundPolicy from './components/pages/info/RefundPolicy';
import AboutUs from './components/pages/info/AboutUs';
import PrivacyPolicy from './components/pages/info/PrivacyPolicy';
import AlgoSignals from './components/pages/landing/landing-comp/AlgoSignals';
import QuikTradeTerminal from './components/pages/landing/landing-comp/QuikTradeTerminal';
import PositionSizingPlanner from './components/pages/planner/PositionSizingPlanner';
import GlobalStorageListener from './GlobalStorageListener';

const TitleHandler = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path === '/terminal') {
      document.title = "Terminal - QuikTrade";
    } else if (path === '/algo-signals') {
      document.title = "Algo Signals - QuikTrade";
    } else {
      document.title = "QuikTrade";
    }
  }, [location.pathname]);
  return null;
};

const App = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <TitleHandler />
      <GlobalStorageListener />
      <Routes>
        <Route path="/" element={<LandingDev />} />
        <Route path="/authentication" element={<AuthLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="logout" element={<Logout />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgetPassword />} />
          <Route path="reset-password" element={<PasswordReset />} />
          <Route path="confirm-mail" element={<ConfirmMail />} />
        </Route>
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/features/algo-signals" element={<AlgoSignals />} />
        <Route path="/features/terminal" element={<QuikTradeTerminal />} />
        <Route path="/trading-tools" element={<PositionSizingPlanner />} />
        <Route path="/errors/*" element={<ErrorLayout />} />
        <Route path="/*" element={<Layout />} />
        <Route path="*" element={<ErrorLayout />} />
      </Routes>
    </Router>
  );
};

export default App;
